import { RequestState } from "../constants/loading";

export interface RequestDescription {
    started: Date;
    ended: Date;
    status: RequestState;
    correlationId: string;
    details?: string;
    eventType?: string;
    data?: unknown;
    url?: string;
    method?: string;
}

export const requestSummary = (desc: RequestDescription) => {
    const details = desc.details || "(not available)";
    const url = desc.url || "(not available)";
    const method = desc.method || "(not available)";
    return `CorrelationId: ${desc.correlationId}, Details: ${details}, URL: ${url}, Method: ${method}`;
};
